import Vue from "vue";
import App from "./App.vue";
import router from "./router/index.js";
import store from "./store/index.js";
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";
import Notifications from "vue-notification";
import VueRouter from "vue-router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "font-awesome/css/font-awesome.css";
import "@/assets/css/style.css";
// import "@/assets/css/notif.scss";
import "@/assets/css/admin.css";
import Astrik from "@/components/Shared/Astrik.vue";
import Loader from "@/components/Loader";
import util from "@/util/util.js";
import moment from "moment";
import Paginate from "vuejs-paginate";
import VModal from "vue-js-modal";

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

localize("en", en);

Vue.prototype.$http = util.http;
Vue.config.productionTip = false;
Vue.use(VueRouter);
Vue.use(VModal, { dialog: true });
Vue.component("Astrik", Astrik);
Vue.component("Loader", Loader);
Vue.use(Notifications);
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);
Vue.component("paginate", Paginate);

Vue.mixin({
  methods: {
    statusHtml(val) {
      if (val == 1) {
        return "<span class='badge bg-success'>Active</span>";
      } else {
        return "<span class='badge bg-danger'>Inactive</span>";
      }
    },
    tokenStatusHtml(val) {
      if (val == 0) {
        return "<span class='badge bg-secondary'>On Queue</span>";
      } else if (val == 1) {
        return "<span class='badge bg-primary'>Current</span>";
      } else if (val == 2) {
        return "<span class='badge bg-success'>Complete</span>";
      } else if (val == 3) {
        return "<span class='badge bg-danger'>Cancelled</span>";
      } else {
        return "<span class='badge bg-warning'>On Hold</span>";
      }
    },
    can(permission) {
      return this.$store.state.permissions.indexOf(permission) != -1;
    },
    isLoggedIn() {
      let token = sessionStorage.getItem("token");
      if (token) {
        return true;
      }
      return false;
    },
    fetchPermissions() {
      util
        .http({
          url: "role/user-permissions",
        })
        .then((resp) => {
          if (resp.data.status == 1) {
            this.$store.commit("setPermissions", resp.data.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    toDMY(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    async fetchIp() {
      await fetch("https://api.ipify.org?format=json")
        .then((x) => x.json())
        .then(({ ip }) => {
          sessionStorage.setItem("ip_address", ip);
        });
    },
  },
});

util.bootEcho();

let app = new Vue({
  router,
  store,
  mounted() {
    this.fetchIp();
    if (this.$router.history.current.path !== "/admin/login") {
      this.fetchPermissions();
    }
  },
  render: (h) => h(App),
}).$mount("#app");
export default app;
